import React from 'react';
import {
  Box, Container, Typography, Button, Grid, Stack, Chip, Avatar, AvatarGroup,
} from '@mui/material';
import { CheckCircle, ArrowForward, Star } from '@mui/icons-material';
import { C, Section } from './theme';

const heroFeatures = [
  'Real, high-traffic websites — no PBNs or link farms',
  'DA/DR 50+ authority score on every placement',
  'Manual, niche-relevant outreach (100% white-hat)',
  'Detailed live report for every backlink delivered',
];

const VpsHero = ({ onGetStarted }) => (
  <Section id="hero" sx={{ background: C.gradientSoft, borderBottom: `1px solid ${C.border}`, pt: { xs: 6, md: 9 }, pb: { xs: 7, md: 10 } }}>
    <Container maxWidth="lg">
      <Grid container spacing={{ xs: 5, md: 6 }} alignItems="center">

        <Grid size={{ xs: 12, lg: 6 }}>
          <Chip label="WHITE-HAT LINK BUILDING" size="small" sx={{
            background: '#FFFFFF',
            color: C.primary,
            fontWeight: 800,
            letterSpacing: '0.1em',
            fontSize: '0.72rem',
            mb: 2.5,
            border: `1px solid ${C.primary}30`,
            borderRadius: '6px',
          }} />

          <Typography variant="h1" sx={{
            fontSize: { xs: '2.1rem', sm: '2.6rem', md: '3.1rem', lg: '3.4rem' },
            fontWeight: 900,
            lineHeight: 1.15,
            color: C.textPrimary,
            mb: 2.5,
            letterSpacing: '-0.03em',
          }}>
            Premium backlinks that{' '}
            <Box component="span" sx={{ color: C.primary }}>
              actually move rankings
            </Box>
          </Typography>

          <Typography sx={{ color: C.textSecondary, fontSize: '1.08rem', lineHeight: 1.65, mb: 4, maxWidth: 520 }}>
            We manually place high-authority, niche-relevant backlinks on real websites —
            fully Google-safe and built to compound your organic traffic month after month.
          </Typography>

          <Stack spacing={1.75} sx={{ mb: 4 }}>
            {heroFeatures.map((feat, idx) => (
              <Stack key={idx} direction="row" spacing={1.5} alignItems="center">
                <CheckCircle sx={{ color: C.success, fontSize: 20 }} />
                <Typography sx={{ color: C.textPrimary, fontWeight: 600, fontSize: '0.94rem' }}>
                  {feat}
                </Typography>
              </Stack>
            ))}
          </Stack>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 4 }}>
            <Button
              variant="contained" size="large"
              endIcon={<ArrowForward />}
              onClick={onGetStarted}
              sx={{
                background: C.primary, color: '#FFFFFF', fontWeight: 700, fontSize: '1rem',
                px: 3.5, py: 1.4, borderRadius: '10px', textTransform: 'none', boxShadow: 'none',
                '&:hover': { background: C.primaryHover, boxShadow: 'none' },
              }}
            >
              View Backlink Packages
            </Button>
          </Stack>

          <Stack direction="row" spacing={2} alignItems="center">
            <AvatarGroup max={4} sx={{ '& .MuiAvatar-root': { width: 34, height: 34, fontSize: '0.8rem', border: '2px solid #FFFFFF' } }}>
              {['R', 'A', 'S', 'M'].map((l) => (
                <Avatar key={l} sx={{ background: C.primary }}>{l}</Avatar>
              ))}
            </AvatarGroup>
            <Box>
              <Stack direction="row" spacing={0.3}>
                {[1, 2, 3, 4, 5].map((s) => <Star key={s} sx={{ color: '#F59E0B', fontSize: 16 }} />)}
              </Stack>
              <Typography sx={{ color: C.textMuted, fontSize: '0.8rem', fontWeight: 600 }}>
                Trusted by 500+ marketers &amp; agencies
              </Typography>
            </Box>
          </Stack>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <Box
            component="img"
            src="/assets/seo-result.png"
            alt="SEO performance improvement from Premium Backlink Services"
            sx={{ width: '100%', height: 'auto', display: 'block' }}
          />
        </Grid>

      </Grid>
    </Container>
  </Section>
);

export default VpsHero;
